import { render } from "./BlogDetailsSchemaJson.vue?vue&type=template&id=4ac2be20"
import script from "./BlogDetailsSchemaJson.vue?vue&type=script&lang=js"
export * from "./BlogDetailsSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__